module.exports = __webpack_public_path__ + "img/11.f20c0e57.png";